import type { RunRow } from "./types";

/** A page of `runs/`, and the run types it can be filtered on. */
export type RunList = { count: number; results: RunRow[]; run_types: Array<{ value: string; label: string }> };

/** "n°142" for a pass, else its type ("Preview"). */
export const passName = (run: RunRow) => (run.pass_number ? `n°${run.pass_number}` : run.run_type.label);
